import React, { useState } from "react";

export default function CreateWorkflowModal({ onClose, onConfirm }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  return (
    <div className="">
      <div className="modal-content">
        <div className="form-group">
          <label>Workflow Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. New Onboarding"
          />
        </div>
        <div style={{ marginBottom: 10 }}></div>
        <div className="form-group">
          <label>Description (optional)</label>
          <input
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Short description"
          />
        </div>
        <div style={{ marginBottom: 10 }}></div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button className="btn-secondary" type="button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary"
            type="button"
            disabled={!name.trim()}
            onClick={() => onConfirm({ name: name.trim(), description })}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
